/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  ListHooksTracesPayload,
  ListHooksTracesPayload$Outbound,
  ListHooksTracesPayload$outboundSchema,
} from "../components/listhookstracespayload.js";

export type ListHooksTracesSecurityOption1 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type ListHooksTracesSecurityOption2 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type ListHooksTracesSecurity = {
  option1?: ListHooksTracesSecurityOption1 | undefined;
  option2?: ListHooksTracesSecurityOption2 | undefined;
};

export type ListHooksTracesRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  listHooksTracesPayload: ListHooksTracesPayload;
};

/** @internal */
export type ListHooksTracesSecurityOption1$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const ListHooksTracesSecurityOption1$outboundSchema: z.ZodMiniType<
  ListHooksTracesSecurityOption1$Outbound,
  ListHooksTracesSecurityOption1
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function listHooksTracesSecurityOption1ToJSON(
  listHooksTracesSecurityOption1: ListHooksTracesSecurityOption1,
): string {
  return JSON.stringify(
    ListHooksTracesSecurityOption1$outboundSchema.parse(
      listHooksTracesSecurityOption1,
    ),
  );
}

/** @internal */
export type ListHooksTracesSecurityOption2$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const ListHooksTracesSecurityOption2$outboundSchema: z.ZodMiniType<
  ListHooksTracesSecurityOption2$Outbound,
  ListHooksTracesSecurityOption2
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function listHooksTracesSecurityOption2ToJSON(
  listHooksTracesSecurityOption2: ListHooksTracesSecurityOption2,
): string {
  return JSON.stringify(
    ListHooksTracesSecurityOption2$outboundSchema.parse(
      listHooksTracesSecurityOption2,
    ),
  );
}

/** @internal */
export type ListHooksTracesSecurity$Outbound = {
  Option1?: ListHooksTracesSecurityOption1$Outbound | undefined;
  Option2?: ListHooksTracesSecurityOption2$Outbound | undefined;
};

/** @internal */
export const ListHooksTracesSecurity$outboundSchema: z.ZodMiniType<
  ListHooksTracesSecurity$Outbound,
  ListHooksTracesSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => ListHooksTracesSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => ListHooksTracesSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function listHooksTracesSecurityToJSON(
  listHooksTracesSecurity: ListHooksTracesSecurity,
): string {
  return JSON.stringify(
    ListHooksTracesSecurity$outboundSchema.parse(listHooksTracesSecurity),
  );
}

/** @internal */
export type ListHooksTracesRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
  ListHooksTracesPayload: ListHooksTracesPayload$Outbound;
};

/** @internal */
export const ListHooksTracesRequest$outboundSchema: z.ZodMiniType<
  ListHooksTracesRequest$Outbound,
  ListHooksTracesRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    listHooksTracesPayload: ListHooksTracesPayload$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
      listHooksTracesPayload: "ListHooksTracesPayload",
    });
  }),
);

export function listHooksTracesRequestToJSON(
  listHooksTracesRequest: ListHooksTracesRequest,
): string {
  return JSON.stringify(
    ListHooksTracesRequest$outboundSchema.parse(listHooksTracesRequest),
  );
}
